import { OrganizationParametersGeneration } from './OrganizationParametersGeneration'
import { saving, setErrors } from '@/containers/OrganizationsManagement/organizationsManagementSlice'

const saveTelecomOrganization = async (organizationData, dispatch, url, headers, sendRequest, { onSuccess } = {}) => {
  dispatch(saving({ loading: true }))

  headers.body = OrganizationParametersGeneration(organizationData)
  await sendRequest(url, headers, (json, status) => {
    dispatch(saving({ loading: false }))
    if (status === 200) {
      onSuccess?.()
    }
    if (json.errors) {
      dispatch(setErrors(json.errors))
    }
  })
}

export default saveTelecomOrganization
